import { useDispatch } from 'react-redux';
import { showMessage } from 'app/store/core/messageSlice';
import { styled } from '@mui/material/styles';
import history from '@history';
import Paper from '@mui/material/Paper';
import { useRequest } from '@main/hooks';
import { recoveryPassword } from 'src/app/api/auth';
import { useContext, useState } from 'react';
import { BootstrapContext } from 'app/bootstrap/BootstrapContext';
import { Capturer } from './Screens/Capturer';
import { Validator } from './Screens/Validator';

const IconBadge = styled('div')(({ theme }) => ({
  width: '20rem',
  aspectRatio: 5 / 1,
}));

export const SignRecovery = () => {
  const { initializeSession, finalizeSession } = useContext(BootstrapContext);

  const Dispatch = useDispatch();

  const [showOTP, setShowOTP] = useState(false);
  const [token, setToken] = useState(undefined);
  const [instructions, setInstructions] = useState(undefined);

  const handleOnForbidden = () => {
    finalizeSession();
  };

  const { makeRequest: tryRecovery, isLoading: isLoadingRecovery } = useRequest(recoveryPassword, {
    onForbidden: handleOnForbidden,
  });

  const onSubmit = (formObtained) => {
    tryRecovery(formObtained).then(({ isOk, successContent }) => {
      if (!isOk || successContent === undefined) return;
      // eslint-disable-next-line camelcase
      const { token_type, message, tokenValidate } = successContent;
      // eslint-disable-next-line camelcase
      const shouldValidate = token_type === 'TwoFactorToken';
      // eslint-disable-next-line camelcase
      if (!shouldValidate) {
        Dispatch(
          showMessage({
            message,
          })
        );
        history.replace('/sign-in');
        return;
      }
      setInstructions(message);
      setToken(tokenValidate);
      setShowOTP(true);
    });
  };

  return (
    <div className="flex flex-col flex-auto items-center sm:justify-center min-w-0">
      <Paper className="max-w-[720px] w-full sm:w-auto min-h-full sm:min-h-auto rounded-0 py-32 px-32 sm:p-48 sm:m-32 sm:rounded-2xl sm:shadow relative">
        <div className="w-full mx-auto sm:mx-0">
          <div className="flex space-x-16 w-full items-center justify-center sm:justify-start flex-row">
            <IconBadge>
              <img
                src="assets/images/brands/brand-extended-colored-001.svg"
                alt="logo de biometrics"
              />
            </IconBadge>
          </div>

          {!showOTP && (
            <Capturer onCapture={onSubmit} isLoading={isLoadingRecovery} className="sm:w-[320px]" />
          )}
          {showOTP && (
            <Validator className="sm:w-[320px]" userInstructions={instructions} token={token} />
          )}
        </div>
      </Paper>
    </div>
  );
};
